export const COMPLETE = 'COMPLETE';
export const DECLINED = 'DECLINED';
export const REJECTED = 'REJECTED';
export const PENDING = 'PENDING';
export const TIMEOUT = 'TIMEOUT';
export const AUTHORIZED = 'AUTHORIZED';
export const PREAUTHORIZED = 'PREAUTHORIZED';

export default COMPLETE;
